/* cl-hdt (boomba): camada interativa do clone do Ecomus 2.2.
   O markup copiado traz os custom elements DELE renomeados (hdt-* -> cl-hdt-*: o prep evita colisao com o
   main.js do Shrine) e sem nenhum <script>. Aqui volta a vida, com a mesma biblioteca do tema dele (Embla 8):
   - cl-hdt-slider / cl-hdt-slideshow / cl-hdt-slider-sync: carrossel Embla com o `config` do proprio elemento
     (defaults do Ecomus: loop false, align start, trimSnaps, skipSnaps, slidesToScroll auto), setas, dots,
     autoplay, fade ([isfade]) e sincronizacao (slider-sync <-> slideshow por aria-controls).
   - cl-hdt-marquee: faixa rolando (speed-factor/direction/pausable), conteudo duplicado ate cobrir 2x a largura.
   - cl-hdt-before-after: o <input type=range> move --percent-val.
   - <video> das secoes: autoplay mudo em loop quando entra na tela (nota do operador: videos reproduzindo).
   - acordeoes (<details> e [aria-expanded]): abrem/fecham.
   Estado de runtime gravado pelo extract (transform/height inline, is-selected...) e limpo antes do init. */
(function () {
  var SEL_SLIDER = 'cl-hdt-slider,cl-hdt-slideshow,cl-hdt-slider-sync,cl-hdt-slider-thumb,cl-hdt-slider-lazy';
  var DEF = { loop: false, align: 'start', containScroll: 'trimSnaps', skipSnaps: true, slidesToScroll: 'auto',
              inViewThreshold: 0.5, autoPlay: 0, pauseOnHover: false, navUI: false, dotUI: false };

  function cfg(el) {
    var c = {};
    try { c = JSON.parse(el.getAttribute('config') || '{}'); } catch (e) {}
    var o = {};
    for (var k in DEF) o[k] = DEF[k];
    for (var j in c) o[j] = c[j];
    return o;
  }

  function unbake(el, vp) {
    var cont = vp.querySelector('.hdt-slider__container');
    if (cont) { cont.style.transform = ''; cont.style.height = ''; }
    var slides = cont ? cont.children : [];
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.transform = '';
      slides[i].classList.remove('is-selected', 'is-in-view', 'is-snapped');
    }
    return cont;
  }

  function sliderFor(id) {
    var el = id && document.getElementById(id);
    return el && el.__clEmbla;
  }

  function init(el) {
    if (el.__clEmbla || !window.EmblaCarousel) return;
    var vp = el.querySelector('.hdt-slider__viewport') || el;
    var cont = unbake(el, vp);
    if (!cont || !cont.children.length) return;
    var o = cfg(el);
    var plugins = [];
    if (o.autoPlay && window.EmblaCarouselAutoplay) {
      plugins.push(window.EmblaCarouselAutoplay({ delay: o.autoPlay, stopOnInteraction: false, stopOnMouseEnter: !!o.pauseOnHover }));
    }
    if (o.autoHeight && window.EmblaCarouselAutoHeight) plugins.push(window.EmblaCarouselAutoHeight());
    // o extract gravou is--enabled: no fade isso vira display:grid (todos os slides no mesmo lugar) ANTES de o Embla
    // medir -> um snap so com todos selecionados. Mede no layout flex e liga o grid depois (como o Ecomus)
    el.classList.remove('is--enabled');
    var opts = { loop: !!o.loop, align: o.align, containScroll: o.loop ? false : o.containScroll, skipSnaps: !!o.skipSnaps,
                 slidesToScroll: o.slidesToScroll, inViewThreshold: o.inViewThreshold,
                 watchDrag: function (api) { return api.scrollSnapList().length > 1; } };
    if (o.startIndex) opts.startIndex = o.startIndex;
    var api = window.EmblaCarousel(vp, opts, plugins);
    el.__clEmbla = api;
    var fade = el.hasAttribute('isfade');
    function mark() {
      var sel = api.selectedScrollSnap(), inview = api.slidesInView(), nodes = api.slideNodes();
      var reg = api.internalEngine().slideRegistry[sel] || [sel];
      nodes.forEach(function (n, i) {
        n.classList.toggle('is-selected', reg.indexOf(i) !== -1);
        n.classList.toggle('is-in-view', inview.indexOf(i) !== -1);
      });
    }
    api.on('init', mark).on('select', mark).on('slidesInView', mark).on('reInit', mark);
    if (fade) {
      try { api.internalEngine().translate.toggleActive(false); api.internalEngine().translate.clear(); } catch (e) {}
      api.on('reInit', function () { try { api.internalEngine().translate.toggleActive(false); api.internalEngine().translate.clear(); } catch (e) {} });
    }
    mark();
    el.classList.add('is--enabled');
    // setas: as do proprio elemento + as de fora com aria-controls=id (layout do Ecomus)
    var id = el.id;
    var prevs = [].slice.call(el.querySelectorAll('button[name="previous"]'));
    var nexts = [].slice.call(el.querySelectorAll('button[name="next"]'));
    if (id) {
      [].slice.call(document.querySelectorAll('button[name="previous"][aria-controls="' + id + '"]')).forEach(function (b) { if (prevs.indexOf(b) === -1) prevs.push(b); });
      [].slice.call(document.querySelectorAll('button[name="next"][aria-controls="' + id + '"]')).forEach(function (b) { if (nexts.indexOf(b) === -1) nexts.push(b); });
    }
    prevs.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); api.scrollPrev(); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); api.scrollNext(); }); });
    function navState() {
      prevs.forEach(function (b) { if (api.canScrollPrev()) b.removeAttribute('disabled'); else b.setAttribute('disabled', 'disabled'); });
      nexts.forEach(function (b) { if (api.canScrollNext()) b.removeAttribute('disabled'); else b.setAttribute('disabled', 'disabled'); });
    }
    api.on('select', navState).on('init', navState).on('reInit', navState);
    navState();
    // dots
    var dots = [].slice.call(el.querySelectorAll('[hdt-slider-dots]'));
    if (id) [].slice.call(document.querySelectorAll('[hdt-slider-dots][aria-controls="' + id + '"]')).forEach(function (d) { if (dots.indexOf(d) === -1) dots.push(d); });
    dots.forEach(function (d) {
      function build() {
        d.innerHTML = api.scrollSnapList().map(function () { return '<button class="hdt-slider__dot" type="button"></button>'; }).join('');
        [].slice.call(d.querySelectorAll('.hdt-slider__dot')).forEach(function (b, i) { b.addEventListener('click', function () { api.scrollTo(i); }); });
        sel();
      }
      function sel() {
        var s = api.selectedScrollSnap();
        [].slice.call(d.querySelectorAll('.hdt-slider__dot')).forEach(function (b, i) { b.classList.toggle('hdt-slider__dot--selected', i === s); });
        var can = api.canScrollPrev() || api.canScrollNext();
        if (can) d.removeAttribute('hidden'); else d.setAttribute('hidden', '');
      }
      build();
      api.on('reInit', build).on('select', sel);
    });
    // contador "1/5"
    [].slice.call(document.querySelectorAll('[aria-controls="' + id + '"] [hdt-slider-current], [hdt-slider-counter][aria-controls="' + id + '"] .current')).forEach(function (c) {
      api.on('select', function () { c.textContent = api.selectedScrollSnap() + 1; });
    });
  }

  function sync() {
    [].slice.call(document.querySelectorAll('cl-hdt-slider-sync[aria-controls]')).forEach(function (s) {
      var a = s.__clEmbla, b = sliderFor(s.getAttribute('aria-controls'));
      if (!a || !b || s.__clSynced) return;
      s.__clSynced = true;
      var lock = false;
      a.on('select', function () { if (lock) return; lock = true; b.scrollTo(a.selectedScrollSnap()); lock = false; });
      b.on('select', function () { if (lock) return; lock = true; a.scrollTo(b.selectedScrollSnap()); lock = false; });
    });
  }

  function marquee(el) {
    // igual ao hdt-marquee dele: duplica o item ate 2x a largura e anima o inner com Web Animations
    // (translateX 0 -> -metade, linear, infinito; velocidade = 300 * speed-factor px/s)
    if (el.__clMq) return;
    var inner = el.querySelector('.hdt-marquee-inner');
    if (!inner || !inner.firstElementChild) return;
    var w = inner.firstElementChild.offsetWidth;
    if (!w) return;
    el.__clMq = 1;
    [].slice.call(inner.querySelectorAll('.hdt-marquee--duplicate')).forEach(function (n) { n.remove(); });
    var n = Math.ceil((2 * el.offsetWidth) / w);
    for (var i = 0; i < n; i++) { var c = inner.firstElementChild.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.classList.add('hdt-marquee--duplicate'); inner.appendChild(c); }
    var speed = 300 * parseFloat(el.getAttribute('speed-factor') || '0.4');
    var rtl = (el.getAttribute('direction') || 'ltr') === 'rtl';
    var r = inner.scrollWidth / 2;
    var from = rtl ? '0px' : '-' + r + 'px', to = rtl ? '-' + r + 'px' : '0px';
    var a = inner.animate([{ transform: 'translateX(' + from + ') translateZ(0)' }, { transform: 'translateX(' + to + ') translateZ(0)' }],
      { duration: (r / speed) * 1000, easing: 'linear', iterations: Infinity });
    if (el.hasAttribute('pausable')) {
      el.addEventListener('mouseenter', function () { a.pause(); });
      el.addEventListener('mouseleave', function () { a.play(); });
    }
  }

  function beforeAfter(el) {
    if (el.__clBf) return;
    el.__clBf = 1;
    var r = el.querySelector('input[type="range"]');
    if (!r) return;
    function upd() { el.style.setProperty('--percent-val', r.value); }
    r.addEventListener('input', upd);
    r.addEventListener('change', upd);
  }

  function videos(root) {
    var vids = [].slice.call((root || document).querySelectorAll('[class*="cl-sec-"] video, .cl-pdp video'));
    if (!vids.length) return;
    function play(v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.loop = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
      }, { rootMargin: '200px' });
      vids.forEach(function (v) { if (!v.hasAttribute('data-cl-noauto')) io.observe(v); });
    } else vids.forEach(play);
  }

  function accordions() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[class*="cl-sec-"] [aria-expanded][aria-controls], [class*="cl-sec-"] [data-cl-acc]');
      if (!t || t.closest('cl-hdt-slider,cl-hdt-slideshow') || t.tagName === 'A') return;
      var id = t.getAttribute('aria-controls');
      var p = id ? document.getElementById(id) : t.nextElementSibling;
      if (!p) return;
      e.preventDefault();
      var open = t.getAttribute('aria-expanded') !== 'true';
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.classList.toggle('is-open', open);
      p.hidden = false;
      p.style.overflow = 'hidden';
      if (open) { p.style.height = p.scrollHeight + 'px'; p.classList.add('is-open'); setTimeout(function () { if (t.getAttribute('aria-expanded') === 'true') p.style.height = 'auto'; }, 300); }
      else { p.style.height = p.scrollHeight + 'px'; p.offsetHeight; p.style.height = '0px'; p.classList.remove('is-open'); }
    });
  }

  /* gaveta de filtros da colecao (dialog#omr-drawer-filter): listas montadas dos cards da pagina, filtro no cliente */
  function filters() {
    var dlg = document.getElementById('omr-drawer-filter');
    if (!dlg || dlg.__cl) return; dlg.__cl = 1;
    var cards = [].slice.call(document.querySelectorAll('cl-hdt-card-product[data-cl-f-size]'));
    var COLORS = {};
    function vals(k) {
      var out = [];
      cards.forEach(function (c) { (c.getAttribute('data-cl-f-' + k) || '').split('|').forEach(function (v) { v = v.trim(); if (v && out.indexOf(v) < 0) out.push(v); }); });
      return out;
    }
    cards.forEach(function (c) {
      c.querySelectorAll('.hdt-color-list-item input').forEach(function (i) {
        var bg = i.parentNode.querySelector('.hdt-color-bg');
        if (bg) COLORS[i.value] = bg.style.background;
      });
    });
    dlg.querySelectorAll('[data-cl-f-list]').forEach(function (ul) {
      var k = ul.getAttribute('data-cl-f-list'), tpl = ul.querySelector('template');
      if (!tpl) return;
      var html = vals(k).map(function (v, i) {
        var e = String(v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
        return tpl.innerHTML.split('__VAL__').join(e).split('__ID__').join(String(i + 1)).split('__BG__').join(COLORS[v] || '#ddd');
      }).join('');
      tpl.insertAdjacentHTML('afterend', html);
      var det = ul.closest('details'); if (det && !html) det.style.display = 'none';
    });
    function openD() { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } dlg.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function closeD() { dlg.classList.remove('is-open'); try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } document.documentElement.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[aria-controls="omr-drawer-filter"]');
      if (b) { e.preventDefault(); if (dlg.contains(b)) closeD(); else openD(); return; }
      if (e.target === dlg) closeD();
      var ra = e.target.closest('cl-omr-facet-url a, [data-cl-f-clear]');
      if (ra) { e.preventDefault(); dlg.querySelectorAll('input[data-cl-f]').forEach(function (i) { i.checked = false; }); apply(); }
    });
    function apply() {
      var sel = {};
      dlg.querySelectorAll('input[data-cl-f]:checked').forEach(function (i) { (sel[i.getAttribute('data-cl-f')] = sel[i.getAttribute('data-cl-f')] || []).push(i.value); });
      var n = dlg.querySelectorAll('input[data-cl-f]:checked').length;
      cards.forEach(function (c) {
        var ok = Object.keys(sel).every(function (k) {
          var have = c.getAttribute('data-cl-f-' + k) || '';
          return sel[k].some(function (v) { return have.indexOf('|' + v + '|') > -1; });
        });
        c.style.display = ok ? '' : 'none';
      });
      document.querySelectorAll('cl-omr-filter-selected [data-count-selected]').forEach(function (s) { s.textContent = n ? n : 'No'; });
      document.querySelectorAll('cl-omr-facet-url').forEach(function (u) { u.style.display = n ? '' : 'none'; });
    }
    dlg.addEventListener('change', function (e) { if (e.target.matches('input[data-cl-f]')) apply(); });
    dlg.querySelectorAll('summary').forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); var d = s.parentNode; if (d.open) d.removeAttribute('open'); else d.setAttribute('open', ''); });
    });
  }

  /* bolinhas de cor dos cards: foto da cor no hover/clique (como o wrapp-hdt-color-list dele) */
  function swatches() {
    function swap(inp) {
      var card = inp.closest('cl-hdt-card-product'); if (!card) return;
      var main = card.querySelector('.hdt-card-product__media--main'), hov = card.querySelector('.hdt-card-product__media--hover');
      var s1 = inp.getAttribute('data-vimg'), s2 = inp.getAttribute('data-vimg2');
      if (main && s1) { main.removeAttribute('srcset'); main.src = s1; }
      if (hov && s2) { hov.removeAttribute('srcset'); hov.src = s2; }
      card.querySelectorAll('.hdt-color-list-item').forEach(function (it) { it.classList.toggle('is--active', it.contains(inp)); });
    }
    document.addEventListener('mouseover', function (e) {
      var it = e.target.closest('cl-hdt-card-product .hdt-color-list-item'); if (!it) return;
      var inp = it.querySelector('input'); if (inp) swap(inp);
    });
    document.addEventListener('change', function (e) { if (e.target.matches('cl-hdt-card-product .hdt-color-list-item input')) swap(e.target); });
  }

  /* central de ajuda (help-center.js dele): abas laterais FAQ/Shipping/Returns/... mostram a secao do id */
  function helpCenter() {
    var links = [].slice.call(document.querySelectorAll('.help-center__side-tab-item a'));
    if (!links.length) return;
    var SEL = '.faq, .shipping-policy, .return-policy, .accessibility, .privacy, .terms-and-service';
    function show(id, scroll) {
      var target = document.getElementById(id);
      if (!target || !target.matches(SEL)) return;
      links.forEach(function (a) { var on = a.getAttribute('href') === '#' + id; a.classList.toggle('clx-active', on); a.classList.toggle('active', on); a.setAttribute('aria-selected', on ? 'true' : 'false'); });
      document.querySelectorAll(SEL).forEach(function (s) { var on = s === target; s.classList.toggle('clx-active', on); s.classList.toggle('active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      if (scroll) setTimeout(function () { window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' }); }, 50);
    }
    links.forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); var id = a.getAttribute('href').replace('#', ''); try { history.replaceState(null, '', '#' + id); } catch (x) {} show(id, true); }); });
    window.addEventListener('hashchange', function () { show(location.hash.replace('#', ''), true); });
    if (location.hash) show(location.hash.replace('#', ''), false);
  }

  /* OwlCarousel da secao "Instantly Lift"/"Adds Up to 2 Cup Sizes" (omr-image-c-mode): o extract congelou larguras do
     desktop (268px). Como o owl dele (retrabalho 10-09, medido no site dele): itens na ORDEM do markup (o 1o, um video,
     a esquerda e tocando), 3 por vez (>= 992px) ou 2; com mais itens que cabem anda sozinho em loop, um item por vez. */
  function owls() {
    [].slice.call(document.querySelectorAll('[class*="cl-sec-"] .owl-carousel')).forEach(function (el) {
      if (el.__clOwl) return; el.__clOwl = 1;
      var outer = el.querySelector('.owl-stage-outer'), stage = el.querySelector('.owl-stage');
      if (!outer || !stage) return;
      var items = [].slice.call(stage.children).filter(function (n) { return n.classList.contains('owl-item') && !n.classList.contains('cloned'); });
      if (!items.length) return;
      // posicao gravada no extract (o owl dele ja tinha andado): clones DELE antes do 1o item real + translate
      var kids = [].slice.call(stage.children), lead = kids.indexOf(items[0]);
      var tx = /translate3d\((-?[\d.]+)px/.exec(stage.style.transform || ''), w0 = parseFloat(items[0].style.width) || 0;
      var idx0 = tx && w0 ? Math.round(-parseFloat(tx[1]) / w0) - lead : 0;
      kids.forEach(function (k) { if (k.classList.contains('cloned')) k.remove(); });
      items.forEach(function (it) { it.style.display = ''; it.style.visibility = ''; });
      [].slice.call(stage.querySelectorAll('video')).forEach(function (v) { v.setAttribute('data-cl-noauto', ''); });
      var clones = [], idx = Math.max(0, Math.min(items.length - 1, idx0)), w = 0, n = 3;
      function frozen() { return navigator.webdriver || document.querySelector('style[data-cl-freeze]'); }
      // medido no site dele: 3 itens em 3 vagas andam em loop (clones do owl); 2 itens ficam parados
      function loops() { return items.length > 2 && items.length >= n; }
      function lay() {
        n = window.innerWidth >= 992 ? 3 : 2;
        clones.forEach(function (c) { c.remove(); }); clones = [];
        // 2 itens em 2 vagas (mobile): o owl dele em loop para no 2o item -> [imagem, video] (medido no site dele)
        var pair = items.length === 2 && n === 2;
        if (pair) idx = 1; else if (!loops()) idx = Math.max(0, Math.min(items.length - 1, idx0));
        if (loops() || pair) items.slice(0, n).forEach(function (it) {
          var c = it.cloneNode(true); c.classList.add('cloned'); c.setAttribute('aria-hidden', 'true'); stage.appendChild(c); clones.push(c);
        });
        var all = items.concat(clones);
        w = outer.clientWidth / n;
        all.forEach(function (i) { i.style.width = w + 'px'; i.style.marginRight = '0px'; });
        stage.style.width = Math.ceil(w * all.length) + 'px';
        go(false);
      }
      function go(anim) {
        stage.style.transition = anim ? 'transform .6s ease' : 'none';
        stage.style.transform = 'translate3d(' + (-idx * w) + 'px, 0px, 0px)';
        [].slice.call(stage.querySelectorAll('video')).forEach(function (v) {
          var it = v.closest('.owl-item'), k = items.concat(clones).indexOf(it), vis = k >= idx && k < idx + n;
          if (vis) { v.muted = true; v.loop = true; var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } else v.pause();
        });
      }
      stage.addEventListener('transitionend', function () {
        if (idx >= items.length) { idx = 0; go(false); }
      });
      lay();
      window.addEventListener('resize', lay);
      setInterval(function () { if (!loops() || frozen() || document.hidden) return; idx++; go(true); }, 4000);
    });
  }

  /* trilho Splide dele (about-us: loop, drag free, autoScroll speed 1) com as classes renomeadas (clx-splide*: colidem
     com o Shrine). Mantem a posicao inicial gravada e anda por setas, paginacao, arraste e auto-scroll continuo. */
  function splides() {
    [].slice.call(document.querySelectorAll('[class*="cl-sec-"] .clx-splide:not(.product-recommend-slider)')).forEach(function (el) {
      if (el.__clSp) return; el.__clSp = 1;
      var track = el.querySelector('.clx-splide__track'), list = el.querySelector('.clx-splide__list');
      if (!track || !list) return;
      var slides = [].slice.call(list.children);
      var real = slides.filter(function (s) { return !s.classList.contains('splide__slide--clone'); });
      var n = real.length; if (!n) return;
      var m = /translateX\((-?[\d.]+)px\)/.exec(list.style.transform || '');
      var x0 = m ? parseFloat(m[1]) : 0, x = x0, w = function () { return real[0].getBoundingClientRect().width || 1; };
      list.style.transition = 'none';
      function wrap() { var span = n * w(); while (x > x0 + span / 2) x -= span; while (x < x0 - span / 2) x += span; }
      function paint(anim) {
        wrap();
        list.style.transition = anim ? 'transform 400ms cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
        list.style.transform = 'translate3d(' + x + 'px,0,0)';
        var idx = ((Math.round((x0 - x) / w()) % n) + n) % n;
        [].slice.call(el.querySelectorAll('.clx-splide__pagination__page')).forEach(function (p, i) { p.classList.toggle('clx-is-active', i === idx); p.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      }
      paint(false);
      var prev = el.querySelector('.clx-splide__arrow--prev'), next = el.querySelector('.clx-splide__arrow--next');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); x += w(); paint(true); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); x -= w(); paint(true); });
      [].slice.call(el.querySelectorAll('.clx-splide__pagination__page')).forEach(function (p, i) {
        p.addEventListener('click', function (e) { e.preventDefault(); x = x0 - i * w(); paint(true); });
      });
      var drag = null, hover = false;
      track.addEventListener('pointerdown', function (e) { drag = { sx: e.clientX, x: x }; track.setPointerCapture && track.setPointerCapture(e.pointerId); });
      track.addEventListener('pointermove', function (e) { if (!drag) return; x = drag.x + (e.clientX - drag.sx); paint(false); });
      var end = function () { drag = null; };
      track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
      track.style.touchAction = 'pan-y';
      el.addEventListener('mouseenter', function () { hover = true; }); el.addEventListener('mouseleave', function () { hover = false; });
      // auto-scroll (1px/quadro, como o autoScroll speed:1 dele); parado quando o instrumento de verificacao congela a pagina
      function tick() {
        if (!drag && !hover && !navigator.webdriver && !document.querySelector('style[data-cl-freeze]')) { x -= 1; paint(false); }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* tabela de medidas do omr.js DELE (PDP: dialog "Size chart"; blog size-guide): .it-header alterna .it-active no
     .it-accor (o CSS do estado aberto vem do omr.css dele, em _global_extra.css). Delegado: o dialog nasce depois. */
  function sizeChart() {
    if (document.__clIt) return; document.__clIt = 1;
    document.addEventListener('click', function (e) {
      var h = e.target.closest('.it-accor > .it-header');
      if (h) h.parentElement.classList.toggle('it-active');
    });
  }

  /* abas do Ecomus (<cl-hdt-tab aria-controls=X> com <button aria-current>; itens [tab-item] de #X, o visivel tem
     [tab-selected]): secao "See BOOMBA in Action" (p06/pd05/pi05). O video da aba aberta toca, os outros pausam. */
  function tabs() {
    if (document.__clTab) return; document.__clTab = 1;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('cl-hdt-tab button');
      if (!b) return;
      var tab = b.closest('cl-hdt-tab'), box = document.getElementById(tab.getAttribute('aria-controls'));
      var btns = [].slice.call(tab.querySelectorAll('button')), i = btns.indexOf(b);
      if (!box || i < 0) return;
      e.preventDefault();
      btns.forEach(function (x, k) { x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      [].slice.call(box.children).filter(function (c) { return c.hasAttribute('tab-item'); }).forEach(function (it, k) {
        if (k === i) it.setAttribute('tab-selected', ''); else it.removeAttribute('tab-selected');
        [].slice.call(it.querySelectorAll('video')).forEach(function (v) {
          if (k === i) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
        });
      });
    });
  }

  /* <omr-video-player> dele (p12 "How to Wear Your Sticky Bras"): o botao de play aparece quando o video pode tocar;
     clique -> toca com controles e o botao some (omr.js) */
  function videoPlayers() {
    [].slice.call(document.querySelectorAll('[class*="cl-sec-"] omr-video-player, [class*="cl-sec-"] cl-omr-video-player')).forEach(function (el) {
      if (el.__cl) return; el.__cl = 1;
      var v = el.querySelector('video'), b = el.querySelector('button');
      if (!v || !b) return;
      v.setAttribute('data-cl-noauto', '');
      // retrabalho 10-09b: o canplay/loadeddata so dispara DEPOIS do clique (preload=metadata) e re-exibia o botao por
      // cima do video tocando. Depois do 1o play o botao nao volta; esconde por estilo inline (sem depender do utilitario).
      var played = false;
      var hide = function () { played = true; b.classList.add('hdt-hidden'); b.style.setProperty('display', 'none', 'important'); };
      var show = function () { if (!played && v.paused) b.classList.remove('hdt-hidden'); };
      if (v.readyState >= 3) show(); else { v.addEventListener('canplay', show, { once: true }); v.addEventListener('loadeddata', show, { once: true }); }
      v.addEventListener('play', hide);
      b.addEventListener('click', function (e) { e.preventDefault(); hide(); v.controls = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    });
  }

  /* "Quick add" dos cards de recomendacao (p15 e new_pr_slider das PDPs): porte do atc-product-recommend.js DELE --
     tamanho pelo <select>, cor = a cor escolhida no buybox, POST /cart/add.js e abre a NOSSA gaveta (nunca vai para a
     pagina do produto). data-variants ja vem com os IDs NOSSOS (pdp_map). */
  function quickAdd() {
    if (document.__clQa) return; document.__clQa = 1;
    function mainColor() { var c = document.querySelector('[name="Color"]:checked, .main-color-swatch.is-active'); return c && c.value ? c.value.toLowerCase().trim() : null; }
    function vars(form) { var i = form.querySelector('.omr-variant-id'); try { return JSON.parse(i.getAttribute('data-variants') || '[]'); } catch (e) { return []; } }
    function images() {
      var col = mainColor(); if (!col) return;
      [].slice.call(document.querySelectorAll('.omr-card-color-gallery')).forEach(function (g) {
        var im = [].slice.call(g.querySelectorAll('.omr-color-image'));
        if (im.some(function (x) { return (x.dataset.color || '').toLowerCase() === col; }))
          im.forEach(function (x) { x.style.display = (x.dataset.color || '').toLowerCase() === col ? 'block' : 'none'; });
      });
    }
    function sizes(form) {
      var sel = form.querySelector('.omr-size-select'), inp = form.querySelector('.omr-variant-id');
      if (!sel || !inp) return;
      var v = vars(form), col = mainColor(), all = v.filter(function (x) { return x.available; }).map(function (x) { return x.size; }), list = all;
      if (col) { list = v.filter(function (x) { return x.available && (x.color || '').toLowerCase() === col; }).map(function (x) { return x.size; }); if (!list.length) list = all; }
      sel.innerHTML = '<option value="" disabled selected>Size</option>';
      list.filter(function (x, i) { return x && list.indexOf(x) === i; }).forEach(function (sz) { var o = document.createElement('option'); o.value = sz; o.textContent = sz; sel.appendChild(o); });
      inp.value = '';
    }
    function pick(form) {
      var sz = (form.querySelector('.omr-size-select') || {}).value, col = mainColor(), inp = form.querySelector('.omr-variant-id');
      if (!sz || !inp) return;
      var v = vars(form), m = v.filter(function (x) { return x.available && x.size === sz && (x.color || '').toLowerCase() === col; })[0] || v.filter(function (x) { return x.available && x.size === sz; })[0];
      if (m) inp.value = m.id;
    }
    var forms = [].slice.call(document.querySelectorAll('.omr-atc-form'));
    images(); forms.forEach(sizes);
    document.addEventListener('change', function (e) {
      if (e.target.matches('[name="Color"], .main-color-swatch')) { images(); [].slice.call(document.querySelectorAll('.omr-atc-form')).forEach(sizes); }
      if (e.target.matches('.omr-size-select')) pick(e.target.closest('.omr-atc-form'));
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.omr-atc-form');
      if (!form) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var vid = (form.querySelector('.omr-variant-id') || {}).value, btn = form.querySelector('.omr-atc-btn'), sel = form.querySelector('.omr-size-select'), msg = form.querySelector('.valid-select');
      btn.classList.remove('error'); if (msg) msg.classList.remove('show');
      if (!sel || !sel.value || !vid) {
        btn.classList.add('error'); if (msg) msg.classList.add('show');
        setTimeout(function () { btn.classList.remove('error'); if (msg) msg.classList.remove('show'); }, 3000);
        return;
      }
      btn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added \u2713';
          if (window.clCart) window.clCart.open();
          setTimeout(function () { btn.textContent = 'Quick add'; }, 1200);
        })
        .catch(function () { btn.textContent = 'Error'; setTimeout(function () { btn.textContent = 'Quick add'; }, 1200); });
    }, true);
  }

  function run() {
    try { quickAdd(); } catch (e) {}
    try { tabs(); } catch (e) {}
    try { videoPlayers(); } catch (e) {}
    try { sizeChart(); } catch (e) {}
    try { splides(); } catch (e) {}
    try { owls(); } catch (e) {}
    try { filters(); } catch (e) {}
    try { helpCenter(); } catch (e) {}
    swatches();
    [].slice.call(document.querySelectorAll(SEL_SLIDER)).forEach(function (el) { try { init(el); } catch (e) { console.warn('cl-hdt slider', e); } });
    sync();
    [].slice.call(document.querySelectorAll('cl-hdt-marquee')).forEach(function (el) { try { marquee(el); } catch (e) {} });
    [].slice.call(document.querySelectorAll('cl-hdt-before-after')).forEach(beforeAfter);
    videos();
  }
  window.clHdt = { run: run, init: init };
  accordions();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
